import {
  WSActions,
  WSControlGroup,
  WSForm,
  WSText
} from "@wingspanhq/fe-component-library";
import { PersonMfaFactor } from "@wingspanhq/wingspan-api-sdk";
import React from "react";
import { mfaFactorLabel } from "./mfaFactorLabel";

type FormData = { factorId: string };

type Props = {
  factors: PersonMfaFactor[];
  submitting: boolean;
  onSubmit: (factorId: string) => void;
};

export const MfaFactorSelectForm: React.FC<Props> = props => (
  <WSForm<FormData>
    onSubmit={data => props.onSubmit(data.factorId)}
    defaultValues={{ factorId: props.factors[0]?.id ?? "" }}
  >
    <WSText color="gray600" mb="XL">
      Choose how you'd like to verify it's you.
    </WSText>

    <WSForm.Field
      mb="2XL"
      name="factorId"
      label="Select"
      component={WSControlGroup}
      componentProps={{
        type: "radio",
        options: props.factors.map(factor => ({
          value: factor.id,
          label: mfaFactorLabel(factor)
        }))
      }}
    />

    <WSActions
      buttons={[
        {
          label: "Continue",
          type: "submit",
          fullWidth: true,
          loading: props.submitting
        }
      ]}
    />
  </WSForm>
);
